<script lang="ts" setup>
  import { useBannerStore } from '@/stores/banner';

  const bannerStore = useBannerStore();
</script>

<template>
  <VMessage :closable="bannerStore.closable">{{
    bannerStore.message
  }}</VMessage>
</template>
